/** Coerces API string/number prices for safe `.toFixed` in bot result cards. */
export function formatBotPrice(value: unknown, fractionDigits = 2): string {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) {
    return (0).toFixed(fractionDigits);
  }
  return n.toFixed(fractionDigits);
}
